import { typographyToCss } from 'shared/lib/mui';
import styled from 'styled-components';

export const Container = styled.label<{ $level?: number; $compact?: boolean }>`
  cursor: pointer;

  ${({ theme }) => typographyToCss(theme.typography.body2)};
  display: inline-flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(2)};

  padding: ${({ theme, $level, $compact }) =>
    `${theme.spacing($compact ? 1 : 1.5)} ${theme.spacing(3)}
    ${theme.spacing($compact ? 1 : 1.5)} ${theme.spacing(3 + ($level ?? 0) * 2)}`};
  margin: 0;
  width: 100%;
  min-width: 0;
  max-width: 100%;

  background: transparent;
  border: none;
  border-radius: ${({ theme }) => theme.spacing(2)};
  transition: background 200ms;

  text-align: left;

  -webkit-app-region: no-drag;
`;

export const AffixContainer = styled.span`
  font-size: 1.6rem;
  line-height: 62.5%;
  color: ${({ theme }) => theme.palette.text.primary};
`;

export const Content = styled.span`
  ${({ theme }) => typographyToCss(theme.typography.body2)};
  flex: 1;
  min-width: 0;

  display: flex;
  gap: ${({ theme }) => theme.spacing(2)};
  justify-content: space-between;
  align-items: center;
`;

export const ButtonContainer = styled.div`
  position: relative;
  width: 59%;
`;

export const PresenceIconSlot = styled.span`
  width: 1.6rem;
  font-size: 1.6rem;
  display: block;
`;

export const ItemContainer = styled.div`
  display: flex;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing(2)};

  padding: ${({ theme }) => theme.spacing(1)};
`;

export const InputsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};
`;

export const Label = styled.label`
  flex: 1;
  ${({ theme }) => typographyToCss(theme.typography.body2)};
  align-self: center;
`;
